import { render, staticRenderFns } from "./export-express-btn.vue?vue&type=template&id=450191d3&"
import script from "./export-express-btn.vue?vue&type=script&lang=js&"
export * from "./export-express-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports